import React, { useCallback, useContext, useEffect, useState } from 'react'
import Constants from '../../Constants'
import { PeFilterContext } from '../../Contexts/PeFilterContext';
import { TableDataContext } from '../../Contexts/TableDataContext';
import axios from 'axios';
import { UserContext } from '../../Contexts/UserContext';
import { toast } from 'react-toastify';
import { useLocation } from 'react-router';
import { authGenerateUrl, authVerifyUrl } from '../../Config/config';

const disabledIds = [4185, 7234, 5580, 9281, 7230];

const ExportPopup = ({exportOptions, onClose, url, fileName}) => {

    const [filterData, setfilterData] = useState(exportOptions);
    const [filterLevel, setfilterLevel] = useState([]);
    const [selectedLeft, setselectedLeft] = useState(filterData.initial?.at(0));
    const [open, setOpen] = useState(false)
    const [showAnimation, setshowAnimation] = useState(false);
    const [showRightAnimation, setshowRightAnimation] = useState(false);
    const [animationCount, setanimationCount] = useState(0);
    const [isExporting, setisExporting] = useState(false);
    const { logout, getToken, authAlert } = useContext(UserContext);
    const { groupId, monthPickerValue, refineSearchFilters, setIocPayload, accessControls } = useContext(PeFilterContext);
    const { tableCompanyId, currency, globalSearchResult } = useContext(TableDataContext);
    const [requestBodyForExport, setRequestBodyForExport] = useState(
        {
            "profile_columns": ["Result Type"],
            "company_id": [],
            "date_range": {
                "from_date": monthPickerValue[0],
                "to_date": monthPickerValue[1]
            },
            fy_year_count: null,
            financial_columns: [],
        }
    )
    const [reachedLimitPopup, setReachedLimitPopup] = useState({ show: false, message: "" })
    const [authCode, setAuthCode] = useState("");
    const [loading, setLoading] = useState(false);
    const location = useLocation();
    const isFromGlobalSearch = ()=> refineSearchFilters[location.pathname]?.globalSearch?.length > 0 ? true : false
    const isMultiCompanySearch = ()=> refineSearchFilters[location.pathname]?.multiCompanySearch?.length > 0 ? true : false
    const isEmptyObject = (object) => Object.values(object).every(x => x == null || x === '' || x === undefined);

    const getRefineFilters = () => {

        //Charge based filters
        const selectedChargeAmt = refineSearchFilters[location.pathname]?.chargeAmount?.at(0)?.value;
        const selectedChargeDate = refineSearchFilters[location.pathname]?.chargeDate?.at(0)?.value;
        const selectedChargeCompanyName = refineSearchFilters[location.pathname]?.chargeCompanies?.map(company => company.id);
        const selectedChargeHolderName = refineSearchFilters[location.pathname]?.chargeHolders?.map(holder => parseInt(holder.id, 10));
        const chargeStateIds = refineSearchFilters[location.pathname]?.chargeState?.map(value => value.id) ?? [];
        const chargeCityIds = refineSearchFilters[location.pathname]?.chargeCity?.map(value => value.id) ?? [];

        //growth based filters
        const IsCAGR = refineSearchFilters[location.pathname]?.growthCAGR?.at(0)?.value;
        const growthOperator = refineSearchFilters[location.pathname]?.growthOperator?.at(0)?.value;
        const yearMatchType = refineSearchFilters[location.pathname]?.growthYear?.at(0)?.value;
        const growthsTemp = refineSearchFilters[location.pathname]?.growthPercentage?.map(option => ({ key: `${option.value?.value}`, value: option.value?.moreThan }))
        const growthsYearsTemp = refineSearchFilters[location.pathname]?.growthPercentage?.map(option => ({ key: `${option.value?.value}_years`, value: option.value?.years }))
        //key value added dynamically
        const growths = growthsTemp?.reduce(
            (obj, item) => Object.assign(obj, { [item.key]: item.value }), {});
        const growthsYears = growthsYearsTemp?.reduce(
            (obj, item) => Object.assign(obj, { [item.key]: item.value }), {});

        //ratio based filters
        const ratioOperator = refineSearchFilters[location.pathname]?.ratioOperator?.at(0)?.value;
        const ratioyearMatchType = refineSearchFilters[location.pathname]?.ratioYear?.at(0)?.value;
        const ratioTemp = refineSearchFilters[location.pathname]?.ratioPercentage
            ?.map(option => option.value)
            ?.map(option => ({ [`${option.filterKey}_min`]: option.min, [`${option.filterKey}_max`]: option.max }))

        const ratio = ratioTemp?.reduce(
            (obj, item) => Object.assign(obj, { ...item }), {});

        //financial based filters

        const financialOperator = refineSearchFilters[location.pathname]?.financialOperator?.at(0)?.value;
        const financialyearMatchType = refineSearchFilters[location.pathname]?.financialYear?.at(0)?.value;
        const financialCurrency = refineSearchFilters[location.pathname]?.financialCurrencyType?.at(0)?.value;
        const financialTemp = refineSearchFilters[location.pathname]?.financialPercentage
            ?.map(option => option.value)
            ?.map(option => ({ [`${option.value}_min`]: option.min, [`${option.value}_max`]: option.max }))

        const financial = financialTemp?.reduce(
            (obj, item) => Object.assign(obj, { ...item }), {});


        const growthReq = {
            "cagr": IsCAGR,
            "range_type": growthOperator,
            "year_match_type": yearMatchType,
            ...growths,
            ...growthsYears
        };

        const ratioReq = {
            "range_type": ratioOperator,
            "year_match_type": ratioyearMatchType,
            ...ratio,
        };

        const financialReq = {
            "range_type": financialOperator,
            "year_match_type": financialyearMatchType,
            "unit": financialCurrency,
            ...financial,
        };

        const payload = {
        company: refineSearchFilters[location.pathname]?.chargeCompanies || [],
        charge_holder_name: refineSearchFilters[location.pathname]?.chargeHolders || [],
        charge_date: selectedChargeDate,
        charge_amount: selectedChargeAmt,
        state: refineSearchFilters[location.pathname]?.chargeState || [],
        city: refineSearchFilters[location.pathname]?.chargeCity || []
        };

        setIocPayload(payload);

        const refineFilters = {
            from: isFromGlobalSearch() || isMultiCompanySearch() ? 'gs' : null,
            registered_names: refineSearchFilters[location.pathname]?.multiCompanySearch?.map(name => name.name),
            industry: refineSearchFilters[location.pathname]?.industry?.length > 0 ? refineSearchFilters[location.pathname]?.industry?.map(value => value.id) : accessControls?.cfsindustries?.id,
            sector: refineSearchFilters[location.pathname]?.sector?.map(value => value.id),
            company_type: refineSearchFilters[location.pathname]?.companyType?.map(type => type.id),
            transaction_status: refineSearchFilters[location.pathname]?.transactionStatus?.map(value => value.id),
            region: refineSearchFilters[location.pathname]?.region?.map(region => region.id),
            state: refineSearchFilters[location.pathname]?.state?.map(state => state.id),
            city: refineSearchFilters[location.pathname]?.city?.map(city => city.id),
            year_founded: refineSearchFilters[location.pathname]?.yearFounded?.at(0) && {
            "from": refineSearchFilters[location.pathname]?.yearFounded[0]?.name,
            "to": refineSearchFilters[location.pathname]?.yearFounded[1]?.name
            },
            auditor_name: refineSearchFilters[location.pathname]?.auditorName?.map(audtior => audtior.name),
            result_type: refineSearchFilters[location.pathname]?.financialType?.at(0)?.id ?? "Both",
            financials: isEmptyObject(financialReq) ? null : financialReq,
            ratios: isEmptyObject(ratioReq) ? null : ratioReq,
            has_ioc : refineSearchFilters[location.pathname]?.syndication?.map(value => value.value)[0] === '0' 
                ? true 
            : refineSearchFilters[location.pathname]?.syndication?.map(value => value.value)[0] === '1' 
                ? false 
            : undefined,
            charges: {
            company: selectedChargeCompanyName,
            charge_holder_name: selectedChargeHolderName,
            charge_date: selectedChargeDate,
            charge_amount: selectedChargeAmt,
            "state": chargeStateIds,
            "city": chargeCityIds,
            },
            growth: isEmptyObject(growthReq) ? null : growthReq,
            tag: {
            operator: refineSearchFilters[location.pathname]?.operator,
            data: refineSearchFilters[location.pathname]?.tags?.map(tag => tag.name)
            },
            group:{  
            group_id: groupId?.myList?.map(id => id.group_id)?.toString() ?? null,
            sub_type_master_id: groupId?.myList?.length >0 ? Constants.subCategoryIds.cfs_id : null   
            }
        }
        console.log(refineFilters, "getRefineFilters");
        return refineFilters;
    }    


    const buildDealColumn = (filterOption, filterData) => {
        let data = [];
        filterData[filterOption?.filterKey]?.filter(filter => filter.isChecked && parseInt(filter.id) !== 100)
            ?.forEach(filter => {
                if (filter.hasMore) {
                    const nestedData = buildDealColumn(filter, filterData);
                    data = [...data.concat(nestedData)];
                } else {
                    data = [...data.concat([filter])];
                }
            })
        if (data.length === 0) {
            filterData[filterOption?.filterKey]?.filter(filter => parseInt(filter.id) !== 100)
                ?.forEach(filter => {
                    if (filter.hasMore) {
                        const nestedData = buildDealColumn(filter, filterData);
                        data = [...data.concat(nestedData)];
                    } else {
                        data = [...data.concat([filter])];
                    }
                })
        }
        return data;
    }

    const getAllSelectedValues = () => {
        const finalResult = {};
    
        // Function to modify column names based on currency
        const getValue = (v) => {
            const dynamic_columns = [
                'Revenue', 
                'EBITDA', 
                'EBDT', 
                'EBT', 
                'PAT', 
                'Opertnl Income', 
                'Interest',
                'Net Inc/Dec In Cash And Cash Equivalents',
                'Net CashFlow From Operating Activities',
                'Net Cash Used In Investing Activities',
                'Net Cash Used From Financing Activities'
            ];
            const postfix = currency === 'INR' ? ' (cr)' : ' (\$ M)';
            return dynamic_columns.includes(v) ? v + postfix : v;
        };
    
        filterData?.initial?.forEach(filter => {
            if (!filter.isChecked) return;
            
            const selected = buildDealColumn(filter, filterData);
            
            const category = filterData?.category[filter?.category];
            
            const groupedColumns = selected.reduce((group, product, i) => {
                // console.log(product, "produkct");
                const { category } = product;
                group[category] = group[category] ?? [];
                if(product?.isChecked && product.value){
                    group[category].push(product);
                }
                return group;
            }, {});
            
            // Iterate over each key in the grouped columns
            for (const key in groupedColumns) {
                if (groupedColumns.hasOwnProperty(key)) {
                    // Create or update the result for this category
                    // Apply getValue to modify column names
                    finalResult[key] = groupedColumns[key].map(item => getValue(item?.value));
                }
            }
        });
        const refine_filters = getRefineFilters();
        
        console.log(finalResult, "getAllSelectedValues result");
        setRequestBodyForExport(prev => ({
            ...prev,
            profile_columns: [...(finalResult.profile_columns), "Result Type"],
            fy_year_count: finalResult.fy_year_count?.[0],
            financial_columns: finalResult.financial_columns ?? [],
            company_id: isFromGlobalSearch() ?  globalSearchResult?.cfs_company : [],
            "is_detailed": true,
            "currency_cd": currency,
            "display_in": currency === "INR" ? "C" : "M",
            "type": 5,
            refine_filters
        }));
        return finalResult;
    };

    useEffect(() => {
        getAllSelectedValues();
    }, [filterData])

    const triggerAnimation = () => {
        setshowAnimation(false);
        setshowRightAnimation(false);
        setanimationCount(prev => prev + 1);
    }


    const triggerRightAnimation = () => {
        setshowRightAnimation(false);
        setanimationCount(prev => prev + 1);
    }
    
    
    useEffect(() => {
        setshowAnimation(true)
        setshowRightAnimation(true);

    }, [animationCount])

    const selectLeftFilter = (option) => {
        setselectedLeft(option);
        triggerRightAnimation();
        if (filterLevel?.length > 1) {
            let temp = [...filterLevel];
            temp[temp.length - 1] = option
            setfilterLevel([...temp])

        }
    }

    const selectRightFilter = (option) => {
        setselectedLeft(option);
        triggerAnimation();

        if (filterLevel?.length > 1) {
            setfilterLevel(prev => ([...prev, option]))
        } else {
            setfilterLevel([selectedLeft, option])
        }
    }

    const changeChildFilterStatus = (filterData, option, isChecked) => {
        let modifiedFilterData = { ...filterData };
        let temp = filterData[option.filterKey]?.map(filter => {
            if (filter.hasMore) {
                modifiedFilterData = changeChildFilterStatus(modifiedFilterData, filter, isChecked)
                return { ...filter, isChecked: isChecked }
            } else {
                return { ...filter, isChecked: isChecked }
            }
        })
        modifiedFilterData = { ...modifiedFilterData, [option.filterKey]: [...temp] }
        return modifiedFilterData;
    }

    const onCheckChange = (e, option) => {
        const { id, checked } = e.target;
        setfilterData(prevFilterData => {
            let modifiedFilterData = { ...prevFilterData };
    
            // Determine the input type based on the parent key
            const isRadioGroup = option.parent === 'financials'; // Adjust this condition as needed
    
            if (isRadioGroup) {
                // For radio button groups, uncheck all other items in the same parent
                modifiedFilterData[option.parent] = modifiedFilterData[option.parent].map(filter => ({
                    ...filter, 
                    isChecked: parseInt(filter.id) === parseInt(id)
                }));
            } else {
                // For checkbox groups
                modifiedFilterData[option.parent] = modifiedFilterData[option.parent].map(filter => {
                    // If this is the specific filter being changed
                    if (parseInt(filter.id) === parseInt(id)) {
                        return { ...filter, isChecked: !filter.isChecked };
                    }
                    
                    // If it's the "All" option
                    if (parseInt(id) === 100) {
                        return { ...filter, isChecked: disabledIds.includes(filter.id) ? true : !option.isChecked };
                    }
                    
                    return filter;
                });
    
                // Update the "All" checkbox status
                const allSelected = modifiedFilterData[option.parent].filter(f => parseInt(f.id) !== 100);
                const allChecked = allSelected.every(f => f.isChecked);
                const allUnchecked = allSelected.every(f => !f.isChecked);
    
                modifiedFilterData[option.parent] = modifiedFilterData[option.parent].map(filter => {
                    if (parseInt(filter.id) === 100 && !allUnchecked) {
                        return { ...filter, isChecked: allChecked };
                    } else if (parseInt(filter.id) === 100 && allUnchecked) {
                        return { ...filter, isChecked: false };
                    }
                    return filter;
                });
            }
    
            // Handle child filters if the current option has more
            if (option.hasMore) {
                modifiedFilterData = changeChildFilterStatus(modifiedFilterData, option, checked);
            }
    
            // Update parent filter status based on child selections
            filterLevel?.forEach((filterLev, index) => {
                if (index !== 0) {
                    const checkedChildren = modifiedFilterData[filterLev.filterKey].filter(filter => filter.isChecked);
                    
                    modifiedFilterData[filterLev.parent] = modifiedFilterData[filterLev.parent].map(filter => {
                        if (filter.filterKey === filterLev.filterKey) {
                            return { 
                                ...filter, 
                                isChecked: checkedChildren.length > 0 
                            };
                        }
                        return filter;
                    });
                }
            });
    
            return modifiedFilterData;
        });
    };

    const downloadExcel = useCallback(async ({ fileName = "file" }) => {
        try {
            console.log(requestBodyForExport, "requestBodyForExport");
            setisExporting(true);

            const response = await axios.post(url, JSON.stringify(requestBodyForExport), {
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": getToken(),
                },
                responseType: 'blob', 
            });

            const contentType = response.headers['content-type'];

            if (contentType === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
                // Handle file download
                const blob = new Blob([response.data], { type: contentType });
                const downloadUrl = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = downloadUrl;
                link.setAttribute('download', `${fileName}.xlsx`);
                document.body.appendChild(link);
                link.click();
                link.remove();
                return { status: true };
            } else {
                // Parse JSON response for non-file content
                const text = await response.data.text();
                const data = JSON.parse(text);
                toast.success(data?.message, { position: "top-center" });
                return { status: true };
            }
        } catch (error) {
            console.error("downloadExcel - error", error);
            if (error?.response?.status === Constants.sessionTerminatedStatus) {
                logout();
            } else if (error?.response?.status === 400) {
                const dataAsText = await error?.response?.data?.text();
                const parsedData = JSON.parse(dataAsText);
                return {
                    status: false,
                    message: parsedData?.message || "An error occurred while exporting",
                };
            }
            return {
                status: false,
                message: error?.response?.data?.message || "An error occurred while exporting",
            };
        } finally {
            setisExporting(false);
        }
    }, [requestBodyForExport, url]);

    const onExportClick = async () => {
        setLoading(true)

        if (authAlert()) {
            try {
                const generateResponse = await axios.post(authGenerateUrl, {}, {
                    headers: {
                        "Authorization": getToken(),
                    },
                });

                if (generateResponse.status === 200) {
                    setReachedLimitPopup({
                        show: true,
                        message: "An authorization code has been sent to your registered email ID. Please enter it below to proceed with data export through the database.",
                    });
                    setLoading(false);
                }
            } catch (error) {
                console.error("Error generating authorization code:", error);
                setLoading(false);
                toast.error("Failed to generate authorization code. Please try again.", { position: "top-center" });
            }
            return;
        }
        setOpen(true);

        const result = await downloadExcel({ fileName });
        if (result.status) {
            onClose();
        } else {
            setReachedLimitPopup({ show: true, message: result.message });
        }
    };

    const handleAuthCodeSubmit = async (code) => {
        try {
            // Step 3: Call authVerifyUrl API with the entered code
            const verifyResponse = await axios.post(authVerifyUrl, { authCode : code }, {
                headers: {
                    "Authorization": getToken(),
                },
            });

            if (verifyResponse.status === 200) {
                // Step 4: Show success message and proceed with export
                toast.success(verifyResponse?.data?.message, { position: "top-center" });
                localStorage.setItem(Constants.localStorageKeys.exportExpireAt, verifyResponse?.data?.export_expires_at );

                setReachedLimitPopup({ show: false, message: "" });
                setOpen(true); // Open the export popup

                // Trigger Excel download
                const result = await downloadExcel({ fileName });
                if (result.status) {
                    onClose();
                } else {
                    setReachedLimitPopup({ show: true, message: result.message });
                }
            }
        } catch (error) {
            console.error("Error verifying authorization code:", error.response.data.message);
            toast.error(error?.response?.data?.message, { position: "top-center" });
        }
    };
    
    if (reachedLimitPopup.show ) {
        if(authAlert()){
            return (
                <div className="fixed inset-0 flex items-center justify-center bg-gray-500 bg-opacity-75 z-10">
                    <div className="relative w-full max-w-lg mx-4 md:mx-0 bg-white rounded-lg shadow-xl">
                        {/* Header */}
                        <div className="pt-5 px-5 flex justify-between items-center">
                            <h1 className="text-lg font-bold text-gray-900">Authorization Required</h1>
                            <button
                                onClick={() => setReachedLimitPopup({ show: false, message: "" })}
                                className="text-gray-500 hover:text-gray-700 text-2xl leading-none"
                            >
                                &times;
                            </button>
                        </div>
    
                        {/* Body */}
                        <div className="p-5">
                            <p className="text-sm text-gray-500">{reachedLimitPopup.message}</p>
                            <div className="mt-4 pl-4 flex items-center gap-2">
                                <input
                                    type="text"
                                    maxLength={8}
                                    // placeholder="52974198"
                                    className="w-28 px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#BC8B20]"
                                    onChange={(e) => setAuthCode(e.target.value)}
                                />
                                <button
                                    onClick={() => handleAuthCodeSubmit(authCode)}
                                    className="px-4 py-2 text-sm font-medium text-white bg-[#BC8B20] rounded-md shadow-sm hover:bg-[#a37517] focus:outline-none"
                                    disabled={authCode.length !== 8}
                                >
                                    Submit
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
    
            );
        }else{
            return (
            <div className="fixed inset-0 flex items-center justify-center bg-gray-500 bg-opacity-75 z-10">
                <div className="relative w-full max-w-lg mx-4 md:mx-0 bg-white rounded-lg shadow-xl">
                    {/* Header */}
                    <div className="p-5">
                        <h1 className="text-lg font-bold text-gray-900">Alert!</h1>
                        <p className="mt-4 text-sm text-gray-500">{reachedLimitPopup.message}</p>
                    </div>
                    {/* Footer */}
                    <div className="flex justify-end bg-gray-50 p-4">
                        <button
                            onClick={onClose}
                            className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md shadow-sm hover:bg-gray-50 focus:outline-none"
                        >
                            Close
                        </button>
                    </div>
                </div>
            </div>
        );
        }
    }

  return (
    <div show={open} className='flex font-sans_book_body cursor-default justify-center items-center z-10 fixed left-0 top-0 w-screen h-screen  bg-gray-500 bg-opacity-75 transition-opacity'>


        <div className='flex flex-col w-[95%] md:w-[60%] h-1/2 bg-white rounded-lg overflow-hidden'>
            <div className='w-full flex flex-col  p-4'>
                <div className='w-full'>
                    
                        <>
                            <h1 className='text-left py-1 text-lg font-bold leading-6 text-gray-900'>Export</h1>
                            <h1 className='text-left text-sm leading-5 text-gray-500'>How do you prefer to export?</h1>
                        </>
                    
                </div>
            </div>
                

            <div className='h-full w-full flex flex-row overflow-auto border-gray-200 border'>

                <div className={`${showAnimation ? "w-[120%] transition-all duration-150" : "w-0"} h-full  text-left overflow-auto border-gray-200 border-r`}>
                {filterData[`${selectedLeft?.parent}`]?.map(option => {
                    if (option.parent === "initial") {
                        return <InitialItems
                            title={option.name}
                            key={option.name}
                            onClick={() => selectLeftFilter(option)}
                            hasMore={option?.hasMore}
                            selected={option?.id === selectedLeft?.id}
                            name={option.parent}
                            id={option.id}
                        />
                    }
                    return <div
                            className={` font-sans_medium_body justify-between cursor-default flex text-left  py-2 pr-2 pl-3 w-full font-medium text-gray-700 border-b border-gray-100 md:w-auto ${option?.id === filterLevel?.at(filterLevel?.length - 1)?.id ? "bg-gray-200" : "hover:bg-gray-50"}`}>
                            <span className='flex text-[13px] items-center'>
                                <input
                                    id={option.id}
                                    disabled={filterLevel?.at(0)?.isChecked === true ? false : true}
                                    className='mr-2 cursor-pointer'
                                    checked={option?.isChecked}
                                    onChange={(e) => onCheckChange(e, option)}
                                    type="checkbox" />
                                <label htmlFor={option.id} >{option.name}</label>
                            </span>
                            {option?.hasMore === true ? <svg onClick={() => selectLeftFilter(option)} className="w-6 h-6 cursor-pointer text-gray-400" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clipRule="evenodd"></path></svg> : <></>}
                        </div>
                    
                })}

                </div>
                <div className={`${showRightAnimation ? "w-full transition-all duration-150" : "w-0"} h-full overflow-auto`}>

                    {
                        filterData[`${selectedLeft?.filterKey}`]?.map(option => {
                            const type = option.parent === 'financials' ? 'radio' : 'checkbox';
                            return <Items
                                key={option.name}
                                title={option?.name ?? ""}
                                id={option?.id}
                                checked={option?.isChecked}
                                onCheckChange={(e) => onCheckChange(e, option)}
                                onClick={() => selectRightFilter(option)}
                                hasMore={option?.hasMore}
                                type={type}
                            />
                        })
                    }
                </div>
            </div>

            <div className='flex bg-gray-50 px-4 py-3 flex-row-reverse'>
                <button type='submit' value="submit" onClose={() => setOpen(false)} onClick={isExporting ? null : onExportClick} className='inline-flex w-full justify-center rounded-md border border-transparent font-sans_bold_body font-medium text-white bg-[#BC8B20] px-4 py-2 text-base shadow-sm hover:bg-[#a37517] ml-3 sm:w-auto' disabled={isExporting}>
                    {isExporting
                            ? <span className='flex items-center'>
                                <span role="status">
                                    <svg className="  mr-2 w-4 h-4 text-gray-200 animate-spin dark:text-gray-600 fill-[#CA8A24]" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor" />
                                        <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill" />
                                    </svg>
                                </span>
                                Exporting
                            </span>
                            :loading ? <>
                                <span className='flex items-center'>
                                <span role="status">
                                    <svg className="  mr-2 w-4 h-4 text-gray-200 animate-spin dark:text-gray-600 fill-[#CA8A24]" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor" />
                                        <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill" />
                                    </svg>
                                </span>
                                Loading
                            </span>
                            </> : "Export"}
                </button>
                <button onClick={onClose} className='items-center inline-flex w-full justify-center font-sans_bold_body rounded-md border border-gray-300 bg-white px-4 py-2 text-base font-medium text-gray-700 shadow-sm hover:bg-gray-50 focus:outline-none  sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm'>
                    Close
                </button>
            </div>
        </div>
    </div>
  )
}

export default ExportPopup

const Items = ({ title, hasMore, checked, onClick, selected, id, onCheckChange, disabled, type = 'checkbox' }) => {
    return <div
        className={` font-sans_medium_body justify-between cursor-default flex text-left  py-2 pr-2 pl-3 w-full font-medium text-gray-700 border-b border-gray-100 md:w-auto ${selected ? "bg-gray-200" : "hover:bg-gray-50"}`}>
        <span className='flex text-[13px] items-center'>
            <input
                id={id}
                disabled={disabledIds.includes(id) ? true : false} //disabled deselect for default values
                className='mr-2 cursor-pointer'
                checked={disabledIds.includes(id) ? true : checked} //disabled deselect for default values
                onChange={onCheckChange}
                type={type}
                name={type === 'radio' ? 'radioGroup' : undefined}
            />
            <label htmlFor={id} >{title}</label>
        </span>
        {hasMore === true ? <svg onClick={onClick} className="w-6 h-6 cursor-pointer text-gray-400" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clipRule="evenodd"></path></svg> : <></>}
    </div>
}


const InitialItems = ({ title, hasMore, onClick, name, id, selected }) => {
    return <div
        className={`transition ease-in-out delay-150 justify-between cursor-pointer flex text-left py-2 pr-2 pl-3 w-full font-sans_medium_body font-medium text-gray-700 border-b border-gray-100 md:w-auto ${selected ? "bg-gray-200" : "hover:bg-gray-50"}`}
        onClick={onClick}>
        <span className='flex text-[13px] items-center'>
            <label key={id} htmlFor={id}>{title}</label>
        </span>
        {hasMore === true ? <svg className="w-6 h-6 cursor-pointer text-gray-400" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clipRule="evenodd"></path></svg> : <></>}
    </div>
}